<template>
  <div id="home">
    <div id="hero-video-box">
      <section class="content">

        <header>
        <h1>NPC Power Club</h1>
        <p>Styrkelyftningsklubb som är aktiv på NPCs anläggningar
        </p>
        <br>
        <br>
        <custom-button primary center to="/about">Om oss</custom-button>
      </header>
      </section>
      <div id="videoContainer">
        <video
          :muted="true"
          :autoplay="true"
          :loop="true"
          :playsinline="true"
          :data-js-videoplayer="true"
          :src="this.isMobile ? mobileVideoSrc : desktopVideoSrc"
          type="video/mp4"
        ></video>

      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from '@/components/Button.vue'
import userHandler from './../services/userHandler'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    CustomButton
  },
  mixins: [validationMixin],
  validations: {
    question: {
      email: {
        email,
        required
      },
      question: {
        required
      }
    }
  },
  data () {
    return {
      desktopVideoSrc:
        'https://firebasestorage.googleapis.com/v0/b/nordicperformancecenter-57600.appspot.com/o/website%2Fwebsite%2Fvideo-desktop-new.mp4?alt=media',
      mobileVideoSrc:
        'https://firebasestorage.googleapis.com/v0/b/nordicperformancecenter-57600.appspot.com/o/website%2Fwebsite%2Fvideo-mobile-new.mp4?alt=media',
      question: {
        email: '',
        question: '',
        sending: false
      }
    }
  },
  computed: {
    ...mapGetters(['isMobile', 'flags']),

    questionFlag () {
      return this.flags['question']
    }
  },
  mounted () {
  },
  created () {
    window.addEventListener('resize', this.handleResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions(['setFlag']),
    status (validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    },
    sendQuestion () {
      this.question.sending = true
      this.setFlag({
        key: 'question',
        value: {
          state: 1,
          msg: 'Frågan har skickats!'
        }
      })

      userHandler
        .sendAQuestion(this.question)
        .then(response => {
          this.question.sending = false
          this.setFlag({
            key: 'question',
            value: {
              state: 1,
              msg: 'Frågan har skickats!'
            }
          })
        })
        .catch(err => {
          this.question.sending = false
          this.setFlag({
            key: 'question',
            value: {
              state: 2,
              msg: 'Ett fel inträffade, försök igen.'
            }
          })
          console.log(err)
        })
    }
  }
}
</script>

<style scoped lang="less">
@import '../styles/variables';
#home {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  li {
    margin-bottom: @margin-normal;
  }
  #hero-video-box {
    overflow: hidden;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    padding: 0 10%;
    width: 100%;
    margin-bottom: 10px;

    .content {
      align-items: center;
      justify-content: center;
      margin-top: 0px;
      header {
        margin-bottom: 20px;
        h1 {
        margin: 0;
        }
      }
      header,
      a,
      button,
      svg {
        z-index: 9;
      }
      .icon {
        color: white;
        cursor: pointer;
        opacity: 0.9;
        position: absolute;
        left: calc(50% - 15px);
        bottom: 20px;
        font-size: 50px;
      }
      label {
        font-weight: bold;
        font-size: @font-size-small;
        margin-bottom: 5px;
      }
    }

    #videoContainer {
      background-color: @color-grey-darkest;
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;

      video,
      img {
        min-height: 100%;
        min-width: 100%;
        width: auto;
        height: auto;
        /* Center the video */
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      img {
        opacity: 0.5;
      }
    }
  }
}

.alt-link {
  color: @color-secondary-dark;
}

#contact {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
}

.form {
  background: white;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.08);
  align-self: center;
  padding: 20px 10px;
  margin: 10px 5px;
  border-radius: @radius-small;
  button {
    margin: 0;
  }
}
@media screen and (max-width: @sm-max-width) {
  .form {
    margin: 10px;
    height: auto;
  }
  .form:first-child {
    margin-bottom: 0;
  }
      header {
        max-width: 450px;
      }
}
</style>
